<template>
  <vz-content class="vz-personal-events">
    <span class="text-h1 mr-10">События</span>
    <div class="flex flex-space-between">
      <vz-switcher
        v-model="currentTab"
        class="mt-15"
        :items="tabs"
        :use-status="false"
        tabs
      />
    </div>

    <div class="vz-personal-events-content">
      <template v-if="firstLoading">
        <vz-actions-skeleton :per-page="pagination.limit" class="vz-personal-events-list"/>
      </template>
      <div v-else class="vz-personal-events-list">
        <template v-if="isOffers">
          <vz-event-card v-for="offer of offerList" :offer="offer"/>
        </template>
        <template v-else>
          <vz-event-card v-for="event of currentList" :event="event"/>
        </template>
      </div>

      <vz-pagination
        v-if="!isOffers"
        v-model="pagination"
        :limits="[6, 12, 18, 24]"
        use-params
        @change="getData"
        @change-limit="eventLimit = $event"
      />
    </div>
  </vz-content>
</template>

<script setup lang="ts">
import {useLocalStorage} from '@vueuse/core'
import VzPagination from '~/components/ui-kit/vz-pagination.vue';
import {
  ActionsTabName,
  EventRecord,
  PersonalOffer,
} from '~/types/components/personal/actions';
import {getEvents, getOfferList} from '~/api/event';
import VzSwitcher from '~/components/ui-kit/vz-switcher.vue';
import VzActionsSkeleton from '~/components/personal/actions/vz-actions-skeleton.vue';
import VzEventCard from '~/components/personal/actions/vz-event-card.vue';

definePageMeta({
  layout: 'cabinet',
})

const eventLimit = useLocalStorage('event-pagination', +(useRoute().query.limit || 6))

const offerList = ref<PersonalOffer[]>()
const list: Record<ActionsTabName, EventRecord[] | false> = reactive({
  event: false,
  news: false,
  action: false,
  notifications: false,
  notificationArchive: false,
})

let pagination = ref({
  limit: eventLimit,
  pages: 10,
  currentPage: +(useRoute().query.page || 1)
})

const tabs = [
  // {
  //   value: 'event',
  //   title: 'События'
  // },
  {
    value: 'news',
    title: 'Новости'
  },
  {
    value: 'action',
    title: 'Акции'
  },
  // {
  //   value: 'notifications',
  //   title: 'Уведомления'
  // },
  // {
  //   value: 'notificationArchive',
  //   title: 'Архив уведомлений'
  // }

  {
    value: 'offers',
    title: 'Предложения',
    params: {}
  }
]

const currentTab = computed({
  get() {
    return (useRoute().query?.tab || 'news') as ActionsTabName
  },
  set(tab: ActionsTabName) {
    useRouter().push({name: 'personal', query: {tab}})
  }
})

const isOffers = computed(() => {
  return currentTab.value as any === 'offers'
})

const currentList = computed(() => {
  return list[currentTab.value] || []
})

const firstLoading = computed(() => {
  return isOffers.value
    ? !offerList.value
    : list[currentTab.value] === false
})

async function getData(): Promise<void> {
  if (isOffers.value) {
    offerList.value = await getOfferList()
  } else {
    const {data, meta} = await getEvents({
      limit: pagination.value.limit,
      page: pagination.value.currentPage,
      code: currentTab.value
    })
    list[currentTab.value] = data
    pagination.value = {
      limit: meta.limit,
      pages: meta.totalPage,
      currentPage: meta.page
    }
  }
}

watch(
  () => currentTab.value,
  () => {
    pagination.value.currentPage = 1
    getData()
  }
)

onMounted(() => {
  getData()
})
</script>

<style lang="scss" scoped>
.vz-personal-events {
  &-content {
    max-width: 1040px;
    margin: 0 auto;
  }

  &-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-rows: auto;
    grid-gap: 12px;
    margin: 20px 0;

    > div {
      height: 100%;
    }
  }

  @media screen and (max-width: ($lg - 1)) {
    &-list {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media screen and (max-width: 460px) {
    &-list {
      grid-template-columns: 1fr;
    }
  }
}
</style>
